import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import imgUrl from "../assets/images/imgUrl";

const earnCards = [
  {
    text: (
      <>
      <b>  Earn a 21% <br></br> incentive on <br></br> contributions <br></br>  made through <br></br>  unique QR code <br></br> referral link. </b> 
      </> 
    ),
    color: 'gradient-blue',
  },
  {
    text: (
      <>
      <b>  Present <i> I Am <br></br>Peacekeeper </i>  <br></br> Gifts and receive <br></br> 7% of proceeds.</b>
      </>
    ),
    color: 'gradient-yellow',
  },
  {
    text: (
      <>
       <b>   Promote <br></br> pledges,campaigns<br></br>   and referrals  for the <i> I Am Peacekeeper    Movement. </i> </b> 
      </>
    ),
    color: "gradient-blue",
  },
  {
    text: (
      <>
      <b> Use your dashboard  <br></br> to track <br></br> referrals, <br></br> earnings and impact. </b> 
      </>
    ),
    color: "gradient-yellow",
  },
  {
    text: (
      <>
      <b>    Earn <br></br>VIP invites.</b>
      </>
    ),
    color: "gradient-blue",
  },
  {
    text: (
      <>
      <b>  Register as a <br></br> referrer  <br></br> for the  <i> I Am Peacekeeper<br></br>  Movement.</i></b>
      </>
    ),
    color: "gradient-yellow",
  },
];

const Rewards = () => {
  return (
    <>
      {/* Home 7Qualities section */}
      <Box
        className="rewardsBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          // position: "relative",
          color: "white",
          px: 2,
        }}
        mb={5}
      >
        {/* Mini Header (Top-Left) */}

        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Rewards Main Container Section  */}
      <Box className="earn-container">

        {/* reward quote section */}
        <div className="earnQuoteBgSection">
          <Typography variant="h6" className="earn-quote">
            Income through values <br />– serving others while
            <br /> supporting yourself.
          </Typography>
        </div>

        {/* Rewards Heading section  */}
        <Box className="">
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading green-title">
                Earn Peacefully
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Earn Cards Grid */}
        <Box mt={3}>
          <Container className="containerDiv">
            <Grid container spacing={3} justifyContent="center">
              {earnCards.map((item, index) => (
                
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                  <Card className={`earn-card ${item.color}`}>
                    <CardContent>
                      <Typography variant="body2" className="earn-text">
                        {item.text}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={2} className="earn-highlight-box" mt={4}>
                <Grid size={12}>
                     <Typography variant="body2" className="highlightText">
           <b>Secure an <i> I Am Peacekeeper </i>  Patron (USD 21,000) or{" "}
           <i> I Am Peacekeeper </i>Partner (USD 12,000) contribution for the{" "}
           <i>Billionaires for Peace Conclave </i> </b> .
            <br />
           Earn 21% on every successful contribution.
          </Typography>
                </Grid>
            </Grid>
          </Container>
        </Box>

         {/* Quiz Heading section  */}
        {/* <Box className="">
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading green-title">
                I Am Peacekeeper Quiz
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Grid
          container
          spacing={3}
          justifyContent="center"
          className="quiz-grid" mt={3}
        >
          <Grid size={{ xs: 12, sm: 3 , md:2 }}>
            <Card className="quiz-circle yellow1">
              <CardContent className="pb-16px">
                <Typography className="quiz-text">
                  7 Quiz Sections, 4 choices
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, sm:3 , md: 2 }}>
            <Card className="quiz-circle teal1">
              <CardContent className="pb-16px">
                <Typography className="quiz-text">
                  Lucky Prize : One I Am Peacekeeper Hamper
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid> */}
      </Box>
    </>
  );
};

export default Rewards;
